import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import Select, { ValueType } from 'react-select';
import { applicationOptions } from '../../stores/applications/selectors';
import { RootState } from '../../stores/store';
import MultiSelect from '../common/MultiSelect';

interface Props extends LocalizeContextProps {
    isMulti?: boolean;
    selected: string[] | string;
    applications: Array<{ label: string, value: string }>;
    selection?: ValueType<{ label: string, value: string }> | null;
    updateSelection: (selection: ValueType<{ label: string, value: string }>) => void;
}

class ApplicationSelect extends React.Component<Props> {
    public componentDidMount() {
        if (this.props.isMulti) {
            this.props.updateSelection(
                this.props.applications.filter((application) =>
                    (this.props.selected as string[]).find((id) => application.value === id))
            );
        } else {
            this.props.updateSelection(this.props.applications.find((application) =>
                application.value === this.props.selected)!);
        }
    }

    public render() {
        const t = this.props.translate;
        return (
          <React.Fragment>
            {!this.props.isMulti ? (
              <Select className={"dropdown-select application-select"} id={"application-select"}
                options={this.props.applications}
                value={this.props.selection}
                onChange={this.handleSelectChange}
              />
            ) : (
              <MultiSelect
                className={"dropdown-select application-multiselect application-select"}id={"application-multiselect"}
                options={this.props.applications.sort((a, b) => {
                  if (a.label.toLowerCase() < b.label.toLowerCase()) {
                    return -1;
                  } else {
                    return 1;
                  }
                })}
                value={this.props.selection}
                onChange={this.handleSelectChange}
              />
            )}
          </React.Fragment>
        );
    }

    private handleSelectChange = (val?: ValueType<{ label: string, value: string }>) => {
        if (this.props.isMulti) {
            this.props.updateSelection((val === null || val === undefined) ? [] : val);
        } else {
            if (val === null || val === undefined) { return; }
            // tslint:disable-next-line:no-any
            this.props.updateSelection(val as any);
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    applications: applicationOptions(state),
});

export default connect(mapStateToProps)(withLocalize(ApplicationSelect));